import { TCustomerPaymentMethodPayload } from "@ephatta/services"
import { useEphattaQuery } from "../../.."
import { useCustomerPaymentMethodService } from "./useCustomerPaymentMethodService"

export const useCustomerPaymentMethodGetList = (payload: TCustomerPaymentMethodPayload) => {
    const service = useCustomerPaymentMethodService()
    return useEphattaQuery(["Customer.PaymentMethod", payload], () => service.getList(payload))
} 